import React from 'react';

import { AUDITORY_MODEL, rbrContactModel, rbrPlansModel } from '../../../../models/step-plans';
import SectionPlans from '../../../../modules/step-plans/section-plans';
import SectionContact from '../../../../modules/step-plans/section-contact';
import RegisterAuditory from '../../../../auditory/component/RegisterAuditory';

const StepPlansV2 = () => (
  <>
    <SectionPlans authoring={rbrPlansModel} />
    <SectionContact authoring={rbrContactModel} />
    <RegisterAuditory authoring={AUDITORY_MODEL} />
  </>
);

export default StepPlansV2;
